<template lang="html">
	<div class="">
		<div class="row">
			<div class="col-12 col-xl-11">
				<div class="cart-item">
					<div class="row">
						<div class="col-12">
							<div class="ic-box f-r" @click="deleteInvoice()">
								<div class="fa fa-trash"></div>
							</div>
						</div>
						<div class="col-12 col-md-8 col-lg-7">
							<div class="item-box clearfix">
								<div class="icon-box blue f-l"></div>
								<div class="detail-box f-l">
									<div class="item-name">
										{{ item.product_name }}
									</div>
									<div class="insurance">
										{{ item.underwritter_name }}
									</div>

									<div class="categories clearfix">
										<div class="category f-l">
											<div class="name f-l">
												Added:
												{{
													moment(
														item.created_date,
													).format('ddd Do')
												}}
											</div>
											<div class="circle f-l"></div>
										</div>
										<div class="category f-l">
											<div class="name f-l">
												{{
													moment(
														item.created_date,
													).format('MM')
												}}
											</div>
											<div class="circle f-l"></div>
										</div>
										<div class="category f-l">
											<div class="name f-l">
												{{
													moment(
														item.created_date,
													).format('YYYY')
												}}
											</div>
											<div class="circle f-l"></div>
										</div>
									</div>
									<div class="price">
										Premium:
										{{
											item.product_account_details
												.currency_code
										}}{{
											utils.numberWithCommas(
												item.invoice_details
													.premium_amount,
											)
										}}
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-4 col-lg-5">
							<div class="action-box">
								<div
									class="btn btn-long bg-yellow"
									@click="makePayment"
								>
									Pay Now
								</div>
								<div
									class="btn btn-long bg-grey"
									@click="getIPF"
								>
									Get IPF
								</div>
							</div>
						</div>
						<div class="col-12">
							<div class="math-box">
								<div class="row">
									<div class="col-12">
										<div class="title-charge">Charges</div>
									</div>
									<div
										class="col-12"
										v-for="(charge, index) in item
											.invoice_details.charges"
										:key="index"
									>
										<div class="item">
											<div class="row">
												<div class="col-8">
													<div class="title">
														{{
															charge.charge_description
														}}
													</div>
												</div>
												<div class="col-4">
													<div class="num">
														{{
															item
																.product_account_details
																.currency_code
														}}
														{{
															utils.numberWithCommas(
																Math.round(
																	charge.amount *
																		100,
																) / 100,
															)
														}}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12">
										<div class="item">
											<div class="row">
												<div class="col-8">
													<div class="title">
														Premium Amount
													</div>
												</div>
												<div class="col-4">
													<div class="num">
														{{
															item
																.product_account_details
																.currency_code
														}}
														{{
															utils.numberWithCommas(
																Math.round(
																	item
																		.invoice_details
																		.premium_amount *
																		100,
																) / 100,
															)
														}}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-12">
										<div class="item total">
											<div class="row">
												<div class="col-8">
													<div class="title">
														TOTAL
													</div>
												</div>
												<div class="col-4">
													<div class="num">
														{{
															item
																.product_account_details
																.currency_code
														}}
														{{
															utils.numberWithCommas(
																Math.round(
																	item
																		.invoice_details
																		.total_amount *
																		100,
																) / 100,
															)
														}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		item: {
			default: function () {
				return {
					name: 'Ladies First',
					underwritter: 'Madison Insurance',
					date: '01',
					month: 'Jan',
					year: '2020',
					reference: 512,
					currency: 'Kes. ',
					price: 4500,
					total: 4500,
					phkt: 2,
					tpo: 20,
				};
			},
		},
	},
	data() {
		return {
			utils,
			moment,
		};
	},
	methods: {
		deleteInvoice() {
			this.$emit('on-delete');
		},
		makePayment() {
			this.$emit('on-payment');
		},
		getIPF() {
			this.$emit('on-ipf');
		},
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.cart-item {
	background: var(--white);
	padding: 25px 15px;
	border-radius: 2px;
	margin: 10px 0;

	.ic-box {
		cursor: pointer;
	}
	.ic-box:hover {
		color: var(--ne-red);
	}
	.action-box {
		.btn-long {
			width: 100%;
			padding: 8px 0;
			margin: 3px 0;
		}
		.bg-yellow {
			color: var(--white);
		}
		.bg-grey {
			background: #bfc7d133;
		}
	}
	.math-box {
		.title-charge {
			color: var(--ne-red);
			font-size: 15px;
			font-weight: 600;
		}
		.col-8,
		.col-4,
		.col-12 {
			margin: 0 !important;
			padding: 0 !important;
		}
		.item {
			padding: 2px 0;
			.title {
				font-size: 13px;
				font-weight: 600;
			}
			.num {
				font-family: var(--font-bold);
				font-size: 16px;
			}
		}
		.item.total {
			.title,
			.num {
				color: #9c7bfc;
			}
		}
	}
	.item-box {
		.item-name {
			font-size: 18px;
			color: var(--text-color);
			font-family: var(--font-bold);
			line-height: 15px;
		}
		.price {
			color: #464855;
			font-size: 14px;
			font-weight: 600;
			line-height: 12px;
		}
		.insurance {
			font-weight: 600;
			color: @grey;
			font-size: 14px;
			color: #6f7faf;
		}
		.categories {
			line-height: 10px;
			margin: 4px 0 12px 0;

			.name {
				font-weight: 600;
				color: #9c7bfc;
				font-size: 13px;
			}
			.circle {
				width: 4px;
				height: 4px;
				border-radius: 50%;
				background: #9c7bfc;
				margin: 2px 10px 0 10px;
			}
		}
		.category:last-child {
			.circle {
				display: none;
			}
		}
	}
	.icon-box {
		background: #22a45d;
		width: 50px;
		height: 50px;
		border-radius: 20px;
		display: inline-block;
		margin: 12px 30px 0 0;
	}
}
</style>
